<template>
  <main v-if="page">
    <HomeHeader v-if="page.header" :content="page.header as HomeHeader" />
    <RepeatableSections v-if="page.sections" :sections="page.sections" />
  </main>
</template>

<script lang="ts">
import HomeHeader from '@/components/sections/header/HomeHeader.vue'
import RepeatableSections from '@/components/sections/RepeatableSections.vue'
import { usePageContent } from '@/composables/usePageContent.ts'

export default {
  name: 'HomePage',
  components: { HomeHeader, RepeatableSections },
  setup() {
    const { page } = usePageContent('home')

    return { page }
  },
}
</script>
